import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { ChangeDetectionStrategy, Component } from '@angular/core';

export interface AgSelectEditorOptionRendererParams {
  pendoId?: (() => string) | ((params: ICellRendererParams) => string);
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'aux-ag-select-editor-option-renderer',
  standalone: true,
  styleUrls: ['ag-select-editor-option-renderer.component.scss'],
  templateUrl: 'ag-select-editor-option-renderer.component.html',
})
export class AgSelectEditorOptionRendererComponent implements ICellRendererAngularComp {
  params!: AgSelectEditorOptionRendererParams & ICellRendererParams;
  pendoId: string | undefined;

  agInit(params: AgSelectEditorOptionRendererParams & ICellRendererParams) {
    this.params = params;

    if (params.pendoId) {
      this.pendoId = params.pendoId(params);
    }
  }

  refresh(): boolean {
    return false;
  }
}
